import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body2, Caption1 } from '@ui/Typography'
import { Button } from '@ui/components/Button'

import { TransactionDto, TransactionHistoryItem } from '@model/TransactionDto'

import { AnimatedSwitch } from '@shared/animations/AnimatedSwitch'
import { Box } from '@shared/components/Box'
import { TransactionStatusIcon } from '@shared/components/StatusIcon'

type TransactionStatusItemProps = {
  subtitle?: string
} & (
  | {
      transaction: TransactionDto
      isCancellable?: boolean
      onCancel?: (tx: TransactionDto) => void
      transactionHistoryItem?: never
    }
  | {
      transaction?: never
      isCancellable?: never
      onCancel?: never
      transactionHistoryItem: TransactionHistoryItem
    }
)

export const TransactionStatusItem: FC<TransactionStatusItemProps> = ({
  transaction,
  subtitle,
  isCancellable,
  transactionHistoryItem,
  onCancel,
}) => {
  const { t } = useTranslation()

  const state = transaction ? transaction.state : transactionHistoryItem.transactionState

  return (
    <Box flex align='center' gap='x8'>
      <TransactionStatusIcon status={state.id} />
      <Box flex direction='column'>
        <AnimatedSwitch activeKey={state.id} variant='morph'>
          <Body2 sensitive medium>
            {state.name}
          </Body2>
        </AnimatedSwitch>

        <Caption1 sensitive color='text-low-em'>
          {subtitle}
        </Caption1>
      </Box>
      {isCancellable && (
        <Box ml='auto'>
          <Button.Danger size='sm' onClick={() => onCancel?.(transaction)}>
            {t('Cancel')}
          </Button.Danger>
        </Box>
      )}
    </Box>
  )
}
